import React from "react";
import MenuItem from "../MenuItem";
import { SubContent } from "../../components/Layout";

export default function SideBarMenuGroup({ commercialId }) {
  return (
    <SubContent className="p-0">
      <MenuItem href={`/groups/${commercialId}/registrationdata`}>Dados Gerais</MenuItem>
      <MenuItem href={`/groups/${commercialId}/graduate`}>Formandos</MenuItem>
      <MenuItem href={`/groups/${commercialId}/costs`}>Planilha de Custos</MenuItem>
      <MenuItem href={`/groups/${commercialId}/draft`}>Rascunho de Orçamento</MenuItem>
      <MenuItem href={`/groups/${commercialId}/calendar`}>Calendário</MenuItem>
      <MenuItem href={`/groups/${commercialId}/attendance`}>Atendimento</MenuItem>
      <MenuItem href={`/groups/${commercialId}/files`}>Arquivos</MenuItem>
      <MenuItem href={`/groups/${commercialId}/products`}>Loja Virtual</MenuItem>
      <MenuItem href={`/groups/${commercialId}/charges`}>Cobrança Extra</MenuItem>
      <MenuItem href={`/groups/${commercialId}/survey`}>Enquetes</MenuItem>
    </SubContent>
  );
}
